import { createFileRoute } from "@tanstack/react-router";
import { legacyRedirectTo } from "@/lib/legacy-redirect";

// Legacy URL /alerts → redirect to /app/alerts.
export const Route = createFileRoute("/alerts/")({
  beforeLoad: legacyRedirectTo("/app/alerts"),
  component: () => null,
});
